import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import appConfig from '../config'
import useGlobalConfigStore from '@/stores/globalConfig'
import usePersistDataStore from '@/stores/persistData'

function useAxios() {
  // console.log("useAxios")
  // const {setLoading}=useGlobalConfigStore()    报错
  // 创建axios实例
  const service = axios.create({
    baseURL: appConfig.apiUrl,
    timeout: 10000, // 请求超时时间
  })

  const setLoading = useGlobalConfigStore.getState().setLoading

  // 请求拦截器
  service.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const token = usePersistDataStore.getState().userInfo.token
      const lang = usePersistDataStore.getState().lang
      setLoading(true)
      config.headers['token'] = token
      config.headers['prefix'] = appConfig.prefix
      config.headers['prefix-name'] = appConfig.prefix_name
      config.headers['lang'] = lang
      // 在这里进行请求拦截的逻辑处理
      if (
        !config.url?.includes('/doLogin') &&
        !config.url?.includes('/doRegister') &&
        !config.url?.includes('/getVerifyCode') &&
        !config.url?.includes('/send_phone_code') &&
        !config.url?.includes('/doRegisterEnterprise') &&
        !config.url?.includes('/resetPassword')
      ) {
        const current = new Date().getTime()
        const expireTime = usePersistDataStore.getState().expireTime
        if (!expireTime || current > expireTime) {
          usePersistDataStore.getState().logOut()
          return Promise.reject(new Error('token expired'))
        }
      }
      return config
    },
    (error: any) => {
      return Promise.reject(error)
    }
  )

  // 响应拦截器
  service.interceptors.response.use(
    (response: AxiosResponse) => {
      const res = response
      setLoading(false)
      return res.data
    },
    (error: any) => {
      // 统一处理错误
      setLoading(false)
      return Promise.reject(error)
    }
  )

  return {
    get(url: string, params?: any) {
      return service.get(url, { params })
    },
    post(url: string, data?: any) {
      return service.post(url, data)
    },
  }
}

export default useAxios
